import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import GlobalStyles from "./global-styles";
import AuthContextProvider from "./context/auth-context";
import { QueryClient, QueryClientProvider } from "react-query";
import SyncProductsProvider from "./context/sync-products-context";

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <SyncProductsProvider>
          <Router>
            <GlobalStyles />
            <App />
          </Router>
        </SyncProductsProvider>
      </AuthContextProvider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);
